/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAutoStoriesIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-auto-stories"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 19.85Q12 19.85 11.86 19.85Q11.72 19.85 11.46 19.77Q11.2 19.7 10.97 19.57Q9.95 18.95 8.82 18.6Q7.7 18.25 6.5 18.25Q5.45 18.25 4.46 18.52Q3.48 18.8 2.55 19.3Q1.98 19.6 1.41 19.27Q0.85 18.95 0.85 18.3L0.85 6.25Q0.85 5.9 1.01 5.58Q1.18 5.25 1.5 5.1Q2.67 4.53 3.94 4.24Q5.2 3.95 6.5 3.95Q7.95 3.95 9.35 4.33Q10.75 4.7 12 5.45L12 17.75Q13.28 16.95 14.68 16.52Q16.07 16.1 17.5 16.1Q18.4 16.1 19.26 16.25Q20.13 16.4 21 16.7Q21 16.7 21 16.7Q21 16.7 21 16.7L21 4.5Q21.4 4.63 21.77 4.76Q22.15 4.9 22.5 5.1Q22.82 5.25 22.99 5.58Q23.15 5.9 23.15 6.25L23.15 18.35Q23.15 19 22.59 19.3Q22.02 19.6 21.45 19.3Q20.52 18.8 19.54 18.52Q18.55 18.25 17.5 18.25Q16.3 18.25 15.18 18.6Q14.05 18.95 13.03 19.57Q12.8 19.7 12.54 19.77Q12.28 19.85 12 19.85ZM15.07 14.15Q14.75 14.43 14.38 14.26Q14 14.1 14 13.68L14 5.72Q14 5.6 14.05 5.47Q14.1 5.35 14.2 5.25L17.9 1.52Q18.2 1.2 18.6 1.38Q19 1.55 19 1.98L19 10.32Q19 10.45 18.94 10.57Q18.88 10.7 18.77 10.8Z" fill={color} />
    </svg>
  );
}
